import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { USER_FID_CARD } from '../../../constants/routes';
import { notifySuccess } from '../../../utils/Notify';
import { ACCOUNT } from '../../../constants/routes';
const EndScreenFidelity = ({ user, store }) => {

  const navigate = useNavigate();
  const [fidelityCardDetail, setFidelityCardDetail] = useState(undefined);
  const { state } = useLocation();
  const numeroClient =
    user?.fidCard?.[0]?.fidelityInfo?.ficheClient?.numeroClient;

  useEffect(() => {
    if (!user.fidCard) {
      return;
    }
    if (state?.fromLogin) {
      notifySuccess('Carte de fidélité ajoutée avec succès');
    }
    if (numeroClient) {
      setFidelityCardDetail(user?.fidCard?.[0]?.fidelityInfo?.ficheClient);
    }
  }, []);

  return fidelityCardDetail && store && store?.api !== 'mongoDb' ? (
    <div id="visit-count-tile" className="white_card">
      <div className="card_text">
        Fidélité Match
        <p className="second_text">
          Nombre de visites : {fidelityCardDetail.compteurVisite}
        </p>
      </div>
      <div className="logo-visit-count-container">
        <div className="fidelity-card-logo">
          <img src={store.logo} alt="logo" />
        </div>
        <p>+1</p>
      </div>
    </div>
  ) : (
    <></>
  );
};

export default EndScreenFidelity;
